/**
 * @generated SignedSource<<62394d42852d09bdbcd3e01f02bb472b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditMcpServerRoute_server$data = {
  readonly authType: string;
  readonly description: string | null | undefined;
  readonly discoveredTools: ReadonlyArray<string>;
  readonly id: any;
  readonly isActive: boolean;
  readonly isOauthAuthorized: boolean;
  readonly name: string;
  readonly resourceCount: number;
  readonly slug: string;
  readonly tokenAuthMethodOverride: string | null | undefined;
  readonly toolCount: number;
  readonly url: string;
  readonly " $fragmentType": "EditMcpServerRoute_server";
};
export type EditMcpServerRoute_server$key = {
  readonly " $data"?: EditMcpServerRoute_server$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditMcpServerRoute_server">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditMcpServerRoute_server",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "authType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discoveredTools",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toolCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourceCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenAuthMethodOverride",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOauthAuthorized",
      "storageKey": null
    }
  ],
  "type": "GraphQLCustomMcpServer",
  "abstractKey": null
};

(node as any).hash = "7fffa6087f1baa235b8966d5584f1e2b";

export default node;
